@if(!isMobile) {
<p-overlayPanel #op [dismissable]="true" [appendTo]="'body'" [showCloseIcon]="false" [styleClass]="'p-0'">
    <ng-container *ngTemplateOutlet="quickStartContent"></ng-container>
</p-overlayPanel>
} @else {
<p-sidebar #sidebar [(visible)]="sidebarVisible" [fullScreen]="true" [styleClass]="'mobile-quick-start-sidebar'" [showCloseIcon]="false">
    <ng-container *ngTemplateOutlet="quickStartContent"></ng-container>
</p-sidebar>
}

<ng-template #quickStartContent>
    <div [ngClass]="isMobile ? 'h-screen flex flex-column' : 'border-round-2xl shadow-6 w-full w-20rem md:w-22rem'">
        <!-- Header -->
        <div class="quick-start-header p-3" [ngClass]="isMobile ? 'flex-shrink-0' : 'text-white border-round-top-2xl'">
            <div class="flex align-items-center justify-content-between">
                <h3 class="m-0 text-lg font-semibold text-white">Quick Start Guide</h3>
                <p-button type="button" [text]="true" 
                    (click)="hide()" [attr.aria-label]="completedSteps < 3 ? 'Minimize' : 'Close'">
                        <i class="pi text-white" [ngClass]="completedSteps < 3 ? 'pi-window-minimize' : 'pi-times'"></i>
                </p-button>
            </div>

            <!-- Progress pills -->
            <div class="flex align-items-center gap-2 mt-3" aria-hidden="true">
                <div class="flex-1 border-round" [style.height.px]="8" [ngClass]="completedSteps >= 1 ? 'bg-green-500' : 'surface-300'">
                </div>
                <div class="flex-1 border-round" [style.height.px]="8" [ngClass]="completedSteps >= 2 ? 'bg-green-500' : 'surface-300'">
                </div>
                <div class="flex-1 border-round" [style.height.px]="8" [ngClass]="completedSteps >= 3 ? 'bg-green-500' : 'surface-300'">
                </div>
            </div>
        </div>

        <!-- Content wrapper -->
        <div [ngClass]="isMobile ? 'flex-1 overflow-auto' : 'quick-start-content-wrapper'">
            <!-- Body -->
            <div class="p-3 surface-card" [ngClass]="isMobile ? 'h-full' : 'border-round-bottom-2xl'">
                
                <!-- Step 1: Set Up Report Recipients -->
                <div class="quick-start-step mb-3">
                    <button type="button" 
                        class="quick-start-header-btn w-full flex align-items-center justify-content-between p-3 border-round"
                        [class.active]="recipientsOpen"
                        (click)="toggleSection('recipients')" 
                        [attr.aria-expanded]="recipientsOpen">
                        <div class="flex align-items-center gap-2">
                            <!-- status indicator -->
                            <span class="border-circle w-1rem m-flex align-items-center justify-content-center h-1rem"
                                [ngClass]="hasReportRecipients ? 'checked-icon' : 'surface-200 text-600'">
                                <ng-container *ngIf="hasReportRecipients">
                                    <i class="pi pi-check" style="font-size:0.5rem"></i>
                                </ng-container>
                            </span>
                            <h4 class="m-0 text-base font-semibold" [ngClass]="!isMobile ? 'md:text-lg' : ''">Set Up Report Recipients</h4>
                        </div>
                        <i class="pi expand-icon" [ngClass]="recipientsOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                    </button>
                    
                    <div class="quick-start-content" [class.open]="recipientsOpen" style="background-color:  var(--bg-body)">
                        <div class="p-3 border-round">
                            <p class="m-0 text-sm mt-2">
                                As the account owner, you'll always receive ASAP reports as your operation's Safety Officer. Add
                                any additional recipients that should receive reports, such as ACSF, your FAA/FSDO contact, or
                                another company safety manager.
                            </p>
                            <p-button severity="secondary" type="button" styleClass="w-full mt-3" (click)="navigateToRecipients()"
                                [disabled]="!asapFormRecipientsUrl" [label]="isMobile ? 'Add Recipient' : 'Add Recipients'"></p-button>
                        </div>
                    </div>
                </div>

                <!-- Step 2: Invite Your Team -->
                <div class="quick-start-step mb-3">
                    <button type="button" 
                        class="quick-start-header-btn w-full flex align-items-center justify-content-between p-3 border-round"
                        [class.active]="teamOpen"
                        (click)="toggleSection('team')" 
                        [attr.aria-expanded]="teamOpen">
                        <div class="flex align-items-center gap-2">
                            <!-- status indicator -->
                            <span class="border-circle w-1rem m-flex align-items-center justify-content-center h-1rem"
                                [ngClass]="hasAddedUsers ? 'checked-icon' : 'surface-200 text-600'">
                                <ng-container *ngIf="hasAddedUsers">
                                    <i class="pi pi-check" style="font-size:0.5rem"></i>
                                </ng-container>
                            </span>
                            <h4 class="m-0 text-base font-semibold" [ngClass]="!isMobile ? 'md:text-lg' : ''">Invite Your Team</h4>
                        </div>
                        <i class="pi expand-icon" [ngClass]="teamOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                    </button>
                    
                    <div class="quick-start-content" [class.open]="teamOpen" style="background-color:  var(--bg-body)">
                        <div class="p-3 border-round">
                            <p class="m-0 text-sm mt-2">
                                Safety is a team effort. Invite your colleagues to join your RISE SMS account so everyone can
                                submit ASAP reports when needed.
                            </p>
                    
                            <p-button severity="secondary" type="button" styleClass="w-full mt-3" (click)="navigateToTeam()"
                                label="Invite Team Members"></p-button>
                        </div>
                    </div>
                </div>

                <!-- Step 3: Share Instant Access -->
                <div class="quick-start-step">
                    <button type="button" 
                        class="quick-start-header-btn w-full flex align-items-center justify-content-between p-3 border-round"
                        [class.active]="shareOpen"
                        (click)="toggleSection('share')" 
                        [attr.aria-expanded]="shareOpen">
                        <div class="flex align-items-center gap-2">
                            <!-- status indicator -->
                            <span class="border-circle w-1rem m-flex align-items-center justify-content-center h-1rem"
                                [ngClass]="hasGeneratedQrCode ? 'checked-icon' : 'surface-200 text-600'">
                                <ng-container *ngIf="hasGeneratedQrCode">
                                    <i class="pi pi-check" style="font-size:0.5rem"></i>
                                </ng-container>
                            </span>
                            <h4 class="m-0 text-base font-semibold" [ngClass]="!isMobile ? 'md:text-lg' : ''">Share Instant Access</h4>
                        </div>
                        <i class="pi expand-icon" [ngClass]="shareOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                    </button>
                    
                    <div class="quick-start-content" [class.open]="shareOpen" style="background-color:  var(--bg-body)">
                        <div class="p-3 border-round">
                            <p class="m-0 text-sm mt-2">
                                Make reporting effortless. Download your ASAP form's QR code and post it where your team can see
                                it. With one quick scan, anyone in your organization can submit a report immediately.
                            </p>
                            <p-button severity="secondary" [disabled]="!asapFormId"
                            styleClass="w-full mt-3" label="Print QR Code"
                                (click)="printQrCode()"></p-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>